import React from 'react';
import styled, { css } from 'styled-components';
import { margin } from 'polished';

interface EmojiLabelProps {
    children?: React.ReactNode;
    position?: {
        top?: string | number;
        right?: string | number;
        bottom?: string | number;
        left?: string | number;
    };
    src: string;
    size?: string;
    spacing?: number;
}

export const EmojiLabel: React.FC<EmojiLabelProps> = ({ children = '', position, src, size, spacing = 0 }) => {
    return (
        <EmojiLabelStyle size={size} position={position} spacing={spacing}>
            <span role="img" aria-label="Emoji">
                {src}
            </span>
            <span>{children}</span>
        </EmojiLabelStyle>
    );
};

interface EmojiLabelStyleProps {
    size?: string;
    spacing?: number;
    position?: {
        top?: string | number;
        right?: string | number;
        bottom?: string | number;
        left?: string | number;
    };
}

const EmojiLabelStyle = styled.span<EmojiLabelStyleProps>`
    display: inline-flex;
    align-items: flex-end;

    > span:first-child {
        font-size: ${({ size = 'inherit' }) => size};
        ${({ spacing }) => margin(0, spacing, 0, 0)};

        ${({ position }) => {
            if (position) {
                const { top, right, bottom, left } = position;
                return css`
                    position: absolute;
                    top: ${top};
                    right: ${right};
                    bottom: ${bottom};
                    left: ${left};
                `;
            }
        }}
    }
`;
